import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, StarIcon } from 'lucide-react';
export function Clients() {
  const [currentClient, setCurrentClient] = useState(0);
  const clients = [{
    name: 'RADICALIDÁ',
    logo: 'https://via.placeholder.com/200x100/9333EA/FFFFFF?text=RADICALIDA'
  }, {
    name: 'ESTUDIO LA',
    logo: 'https://via.placeholder.com/200x100/7C3AED/FFFFFF?text=ESTUDIO+LA'
  }, {
    name: 'ARIV HOME',
    logo: 'https://via.placeholder.com/200x100/6366F1/FFFFFF?text=ARIV+HOME'
  }, {
    name: 'PREMO',
    logo: 'https://via.placeholder.com/200x100/8B5CF6/FFFFFF?text=PREMO'
  }];
  const testimonials = [{
    client: 'RADICALIDÁ',
    text: 'KONTAXES ha transformado completamente nuestra gestión contable. Su profesionalismo y uso de tecnología Odoo nos permite tener información financiera en tiempo real.',
    author: 'Director General'
  }, {
    client: 'ESTUDIO LA',
    text: 'La asesoría fiscal de KONTAXES es excepcional. Nos han ayudado a optimizar nuestros procesos y cumplir con todas las obligaciones tributarias sin complicaciones.',
    author: 'Gerente Financiero'
  }, {
    client: 'ARIV HOME',
    text: 'Trabajar con KONTAXES ha sido una excelente decisión. Su equipo es altamente capacitado y siempre están disponibles para resolver nuestras dudas.',
    author: 'Propietario'
  }, {
    client: 'PREMO',
    text: 'La implementación de Odoo por parte de KONTAXES ha mejorado significativamente nuestra eficiencia operativa. Recomendamos sus servicios ampliamente.',
    author: 'CEO'
  }];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentClient(prev => (prev + 1) % clients.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [clients.length]);
  const nextClient = () => {
    setCurrentClient(prev => (prev + 1) % clients.length);
  };
  const prevClient = () => {
    setCurrentClient(prev => (prev - 1 + clients.length) % clients.length);
  };
  return <section id="clientes" className="py-20 bg-white dark:bg-gray-900" data-id="element-47">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <div className="text-center mb-16" data-id="element-49">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-50">
            Nuestros Clientes
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400" data-id="element-51">
            Empresas que confían en nosotros
          </p>
        </div>

        {/* Client Logos Carousel */}
        <div className="relative mb-16" data-id="element-52">
          <div className="flex items-center justify-center" data-id="element-53">
            <button onClick={prevClient} className="absolute left-0 p-3 bg-purple-600 hover:bg-purple-700 text-white rounded-full shadow-lg transition-all z-10" data-id="element-54">
              <ChevronLeftIcon size={24} data-id="element-55" />
            </button>

            <div className="flex items-center justify-center space-x-8 overflow-hidden" data-id="element-56">
              {clients.map((client, index) => <div key={index} className={`transition-all duration-500 ${index === currentClient ? 'scale-110 opacity-100' : 'scale-90 opacity-40'}`} data-id="element-57">
                  <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-lg" data-id="element-58">
                    <img src={client.logo} alt={client.name} className="h-24 w-auto mx-auto" data-id="element-59" />
                  </div>
                </div>)}
            </div>

            <button onClick={nextClient} className="absolute right-0 p-3 bg-purple-600 hover:bg-purple-700 text-white rounded-full shadow-lg transition-all z-10" data-id="element-60">
              <ChevronRightIcon size={24} data-id="element-61" />
            </button>
          </div>

          <div className="flex justify-center mt-6 space-x-2" data-id="element-62">
            {clients.map((_, index) => <button key={index} onClick={() => setCurrentClient(index)} className={`w-3 h-3 rounded-full transition-all ${index === currentClient ? 'bg-purple-600 w-8' : 'bg-gray-300 dark:bg-gray-700'}`} data-id="element-63" />)}
          </div>
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-2 gap-8" data-id="element-64">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-gradient-to-br from-purple-50 to-white dark:from-gray-800 dark:to-gray-900 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300" data-id="element-65">
              <div className="flex items-center mb-4" data-id="element-66">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={20} className="text-yellow-400 fill-current" data-id="element-67" />)}
              </div>
              <p className="text-gray-700 dark:text-gray-300 mb-4 italic" data-id="element-68">
                "{testimonial.text}"
              </p>
              <div className="border-t border-gray-200 dark:border-gray-700 pt-4" data-id="element-69">
                <p className="font-bold text-gray-900 dark:text-white" data-id="element-70">
                  {testimonial.client}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-71">
                  {testimonial.author}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}